import useApiQuery from 'shared/hooks/use-api-query';
import {PermissionGroupProps} from '../types';

const usePermissionGroupsForCompaniesSelect = () => {
  const {data = [], ...query} = useApiQuery<PermissionGroupProps[]>({
    url: '/permission-groups/companies/all',
  });

  return {
    data: data?.map((group) => ({label: group.name, value: group.id})),
    ...query,
  };
};

export default usePermissionGroupsForCompaniesSelect;
